(function () {
  'use strict';

  var bodyEl = document.body;
  var behavior = (bodyEl && bodyEl.dataset && bodyEl.dataset.cartBehavior) || 'page';
  var atcBehavior = (bodyEl && bodyEl.dataset && bodyEl.dataset.atcBehavior) || 'popup';
  var drawerEl = document.getElementById('kg-cart-drawer');
  var panelEl = drawerEl ? drawerEl.querySelector('[data-cart-panel]') : null;
  var backdropEl = drawerEl ? drawerEl.querySelector('[data-cart-backdrop]') : null;
  var itemsEl = drawerEl ? drawerEl.querySelector('[data-cart-items]') : null;
  var subtotalEl = drawerEl ? drawerEl.querySelector('[data-cart-subtotal]') : null;

  function onHeaderCartClick(e) {
    if (behavior !== 'drawer') return; // normal navigation
    if (!drawerEl) return;
    e.preventDefault();
    refreshCart().then(function () {
      openDrawer();
    });
  }

  function openDrawer() {
    if (!drawerEl) return;
    drawerEl.setAttribute('aria-hidden', 'false');
    drawerEl.classList.add('is-open');
    document.documentElement.classList.add('kg-cart-open');
    if (document.body) document.body.classList.add('kg-cart-open');
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.setAttribute('aria-hidden', 'true');
    drawerEl.classList.remove('is-open');
    document.documentElement.classList.remove('kg-cart-open');
    if (document.body) document.body.classList.remove('kg-cart-open');
  }

  function fetchJSON(url, options) {
    return fetch(url, Object.assign({
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }, options)).then(function (r) {
      if (!r.ok) throw new Error('Request failed: ' + r.status);
      return r.json();
    });
  }

  function refreshCart() {
    return fetchJSON('/cart.js').then(function (cart) {
      renderCart(cart);
      return cart;
    }).catch(function (err) {
      console.warn('Cart fetch failed', err);
      throw err;
    });
  }

  function formatMoney(cents) {
    var amountNumber = (Number(cents) || 0) / 100;
    var locale = 'de-DE';
    try {
      var pageLang = (document.documentElement && document.documentElement.lang) || '';
      if (pageLang) locale = pageLang;
    } catch (e) {}
    var absFormatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Math.abs(amountNumber));
    return (amountNumber < 0 ? '-' : '') + absFormatted + ' €';
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  var productJsonCache = {};

  function getVariantCompareAtPrice(handle, variantId) {
    if (!handle) return Promise.resolve(null);
    if (productJsonCache[handle]) {
      return Promise.resolve(findCompare(productJsonCache[handle], variantId));
    }
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('product json');
        return r.json();
      })
      .then(function (product) {
        productJsonCache[handle] = product;
        return findCompare(product, variantId);
      }).catch(function () {
        return null;
      });

    function findCompare(product, variantId) {
      if (!product || !Array.isArray(product.variants)) return null;
      var v = product.variants.find(function (vv) {
        return String(vv.id) === String(variantId);
      });
      return v && v.compare_at_price ? v.compare_at_price : null;
    }
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';

    if (!cart || !cart.items || cart.items.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'kg-cart-empty';
      empty.textContent = (window.themeStrings && themeStrings.cart_empty) || 'Ihr Warenkorb ist leer';
      itemsEl.appendChild(empty);
    } else {
      cart.items.forEach(function (item, index) {
        var article = document.createElement('article');
        article.className = 'kg-cart-item';
        article.setAttribute('data-cart-item', '');
        article.setAttribute('data-line', String(index + 1));

        var optionsHtml = '';
        var optionPairs = Array.isArray(item.options_with_values) ? item.options_with_values.filter(function (ov) {
          if (!ov) return false;
          var name = String(ov.name || '');
          var value = String(ov.value || '');
          return name.toLowerCase() !== 'title' && value.toLowerCase() !== 'default title';
        }) : [];

        if (optionPairs.length) {
          optionsHtml = '<ul class="kg-cart-item-opts">' + optionPairs.map(function (ov) {
            return '<li>' + escapeHtml(ov.name) + ': ' + escapeHtml(ov.value) + '</li>';
          }).join('') + '</ul>';
        } else if (item.variant_title && item.variant_title !== 'Default Title') {
          optionsHtml = '<div class="kg-cart-item-options">' + escapeHtml(item.variant_title) + '</div>';
        }

        var skuHtml = item.sku ? '<div class="kg-cart-item-sku">SKU: ' + escapeHtml(item.sku) + '</div>' : '';

        article.innerHTML = [
          '<a class="kg-cart-item-image" href="' + item.url + '">',
          (item.image ? '<img class="kg-cart-item-img" src="' + item.image + '" alt="">' : ''),
          '</a>',
          '<div class="kg-cart-item-main">',
          '<a class="kg-cart-item-title" href="' + item.url + '">' + item.product_title + '</a>',
          optionsHtml,
          skuHtml,
          '<div class="kg-cart-item-unit"><span>Preis</span> <span class="money" data-unit-price>' + formatMoney(item.final_price) + '</span> <span class="money kg-cart-item-compare" data-compare-price style="display:none"></span></div>',
          '<div class="kg-cart-item-price money">' + formatMoney(item.final_line_price) + '</div>',
          '<div class="kg-cart-qty">',
          '<button class="kg-cart-qty-btn" data-qty-decrease aria-label="decrease">−</button>',
          '<input class="kg-cart-qty-input" data-qty-input type="number" min="0" value="' + item.quantity + '">',
          '<button class="kg-cart-qty-btn" data-qty-increase aria-label="increase">＋</button>',
          '<button class="kg-cart-remove" data-remove aria-label="remove">×</button>',
          '</div>',
          '</div>'
        ].join('');

        itemsEl.appendChild(article);

        var setCompare = function (compare) {
          var compareEl = article.querySelector('[data-compare-price]');
          if (!compareEl) return;
          if (compare && compare > item.final_price) {
            compareEl.style.display = '';
            compareEl.textContent = formatMoney(compare);
          } else {
            compareEl.style.display = 'none';
          }
        };

        if (item.compare_at_price) {
          setCompare(item.compare_at_price);
        } else {
          getVariantCompareAtPrice(item.handle, item.id).then(setCompare);
        }
      });
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var event = new CustomEvent('cartcount:update', { detail: { item_count: cart.item_count } });
    window.dispatchEvent(event);
  }

  function changeLine(line, quantity) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function onDrawerClick(e) {
    var target = e.target;
    if (!target) return;

    if (target.closest && target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }

    if (target === backdropEl) {
      closeDrawer();
      return;
    }

    var itemEl = target.closest('[data-cart-item]');
    if (!itemEl) return;

    var line = parseInt(itemEl.getAttribute('data-line'), 10);

    if (target.matches('[data-qty-increase]')) {
      var input = itemEl.querySelector('[data-qty-input]');
      var qty = parseInt(input.value || '0', 10) + 1;
      input.value = String(qty);
      changeLine(line, qty);
    } else if (target.matches('[data-qty-decrease]')) {
      var inputD = itemEl.querySelector('[data-qty-input]');
      var qtyD = Math.max(0, parseInt(inputD.value || '0', 10) - 1);
      inputD.value = String(qtyD);
      changeLine(line, qtyD);
    } else if (target.matches('[data-remove]')) {
      changeLine(line, 0);
    }
  }

  function onQtyInputChange(e) {
    var input = e.target;
    if (!input.matches('[data-qty-input]')) return;

    var itemEl = input.closest('[data-cart-item]');
    if (!itemEl) return;

    var line = parseInt(itemEl.getAttribute('data-line'), 10);
    var qty = Math.max(0, parseInt(input.value || '0', 10));
    changeLine(line, qty);
  }

  function bindEvents() {
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', onHeaderCartClick);
  });

  if (!drawerEl) return;

  drawerEl.addEventListener('click', onDrawerClick);
  drawerEl.addEventListener('change', onQtyInputChange);

  var pendingATC = false;

  function armATCFlag() {
    pendingATC = true;
    setTimeout(function () {
      pendingATC = false;
    }, 4000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form--atc-button, .order-page__atc-button, button[name="add"], [data-add-to-cart]');
    if (btn) armATCFlag();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], form[data-product-form]');
    if (form) armATCFlag();
  });

  window.addEventListener('cartcount:update', function () {
    if (atcBehavior === 'drawer' && pendingATC) {
      refreshCart().then(function () {
        openDrawer();
        pendingATC = false;
      }).catch(function () {
        pendingATC = false;
      });
    }
  });

  window.addEventListener('pageshow', function () {
    closeDrawer();
    refreshCart().then(function () {
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  });
}

if (behavior === 'drawer') {
  bindEvents();
} else {
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {});
  });
}
})();